export default __webpack_public_path__ + "static/featuredImage-87a0884c1943ee263c639543031cd99f.webp";